var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fleches_logos fleches_logos-4"},[_c('img',{staticClass:"arrows",staticStyle:{"display":"none"},attrs:{"src":require("../../img/left-arrow.webp"),"alt":"Arrows / left arrow"}}),_c('img',{staticClass:"arrows variant-1",staticStyle:{"display":"none"},attrs:{"src":require("../../img/right-arrow.webp"),"alt":"Arrows / right arrow"}})])
}]

export { render, staticRenderFns }